/* Homepage only. Native links remain links; no cart/form backend is replaced. */
(() => {
  'use strict';
  const home = document.querySelector('.loom-dore-home');
  if (!home || home.dataset.ldhReady) return;
  home.dataset.ldhReady = 'true';
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  function init(scope) {
    scope.querySelectorAll('[data-ldh-carousel]').forEach(root => {
      if (root.dataset.ldhReady) return;
      root.dataset.ldhReady = 'true';
      const track = root.querySelector('[data-ldh-track]');
      const previous = root.querySelector('[data-ldh-prev]');
      const next = root.querySelector('[data-ldh-next]');
      const state = () => {
        if (previous) previous.disabled = track.scrollLeft < 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => track.scrollBy({left:direction * Math.max(240, track.clientWidth * .8), behavior:motion()});
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', state, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      const tabs = [...root.querySelectorAll('[data-ldh-tab]')];
      const select = button => {
        tabs.forEach(tab => {
          tab.setAttribute('aria-selected', String(tab === button));
          tab.tabIndex = tab === button ? 0 : -1;
        });
        root.querySelectorAll('[data-ldh-card]').forEach(card => {
          card.hidden = button.dataset.ldhTab !== 'all' && card.dataset.kind !== button.dataset.ldhTab;
        });
        track.setAttribute('aria-labelledby', button.id);
        track.scrollTo({left:0, behavior:'instant'});
        state();
      };
      tabs.forEach((button, i) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          const key = event.key;
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(key)) return;
          event.preventDefault();
          const index = key === 'Home' ? 0 : key === 'End' ? tabs.length - 1 : (i + (key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[index].focus(); select(tabs[index]);
        });
      });
      new ResizeObserver(state).observe(track);
      state();
    });
    scope.querySelectorAll('[data-ldh-card]').forEach(card => {
      if (card.dataset.ldhReady) return;
      card.dataset.ldhReady = 'true';
      const buttons = [...card.querySelectorAll('[data-ldh-card-color]')];
      let sequence = 0;
      buttons.forEach(button => button.addEventListener('click', async () => {
        const request = ++sequence;
        const error = card.querySelector('[data-ldh-card-error]');
        card.setAttribute('aria-busy','true'); error.textContent = '';
        try {
          const primary = new Image(); primary.src = button.dataset.primary;
          const hover = new Image(); hover.src = button.dataset.hover;
          await Promise.all([primary.decode(), hover.decode()]);
          if (request !== sequence) return;
          const image = card.querySelector('[data-ldh-card-image]');
          const alternate = card.querySelector('[data-ldh-card-hover]');
          [image, alternate].forEach(img => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); });
          image.src = primary.src; alternate.src = hover.src;
          const title = card.querySelector('.ldh-card-title').textContent;
          const quantity = card.dataset.kind === 'duo' ? 'Voorbeeld: 6 paar, 3 wit + 3 zwart' : 'Eén paar afgebeeld';
          image.alt = `${title}, ${button.dataset.label}. ${quantity}`;
          const note=(hover.src.includes('fb16-high')||hover.src.includes('fr2-high'))?'Gedragen voorbeeld; tagkleur buiten beeld':(hover.src.includes('fb16-ankle')||hover.src.includes('fr2-ankle'))?'Gedragen voorbeeld in Koraal':'';
          alternate.alt = note ? `${title}. ${note}. ${hover.src.includes('duo-onfeet')?'Wit en zwart, niet de volledige packhoeveelheid':'Eén paar'}` : `${title}, ${button.dataset.label}. ${quantity}`;
          card.querySelectorAll('[data-ldh-product-link]').forEach(link => {
            link.href = button.dataset.url;
            if (link.hasAttribute('aria-label')) link.setAttribute('aria-label',`${title}, ${button.dataset.label}`);
          });
          card.querySelector('[data-ldh-card-price]').textContent = button.dataset.price;
          card.querySelector('[data-ldh-card-color-label]').textContent = button.dataset.label;
          buttons.forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        } catch (_) {
          if (request === sequence) error.textContent = 'Het kleurbeeld kon niet laden. Je vorige keuze blijft staan.';
        } finally { if (request === sequence) card.removeAttribute('aria-busy'); }
      }));
    });
  }
  init(home);
  document.addEventListener('shopify:section:load', event => {
    if (home.contains(event.target)) init(event.target);
  });
})();
